var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Button.tsx
import { forwardRef } from "react";
import { default as MUIButton } from "@mui/material/Button";
import { jsx } from "react/jsx-runtime";
var overrideProps = {
  disableRipple: true,
  disableFocusRipple: true,
  disableTouchRipple: true
};
var Button = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(MUIButton, __spreadProps(__spreadValues(__spreadValues({}, props), overrideProps), { ref }));
});

// src/lib/ButtonGroup.tsx
import { default as MUIButtonGroup } from "@mui/material/ButtonGroup";
import { jsx as jsx2 } from "react/jsx-runtime";
var overrideProps2 = {
  disableElevation: true,
  disableFocusRipple: true,
  disableRipple: true
};
var ButtonGroup = (props) => {
  return /* @__PURE__ */ jsx2(MUIButtonGroup, __spreadProps(__spreadValues(__spreadValues({}, props), overrideProps2), { variant: "contained", color: "tertiary" }));
};

// src/lib/IconButton.tsx
import { forwardRef as forwardRef2 } from "react";
import { default as MuiIconButton } from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { jsx as jsx3 } from "react/jsx-runtime";
var outlinedStyles = {
  borderRadius: ".25rem",
  border: 1
};
var IconButton = forwardRef2((props, ref) => {
  const _a = props, { title, variant = "text", sx, size = "medium" } = _a, rest = __objRest(_a, ["title", "variant", "sx", "size"]);
  const styles = __spreadValues(__spreadValues({}, sx), variant === "outlined" && outlinedStyles);
  return /* @__PURE__ */ jsx3(Tooltip, { title, children: /* @__PURE__ */ jsx3(MuiIconButton, __spreadProps(__spreadValues({ "aria-label": title, sx: __spreadValues({}, styles) }, rest), { ref, size })) });
});

// src/lib/LoadingButton.tsx
import { forwardRef as forwardRef3 } from "react";
import MUILoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import { jsx as jsx4 } from "react/jsx-runtime";
var LoadingIndicator = /* @__PURE__ */ jsx4(CircularProgress, { color: "inherit", size: 16, "aria-label": "loading" });
var LoadingButton = forwardRef3((props, ref) => {
  const _a = props, { children, loading } = _a, rest = __objRest(_a, ["children", "loading"]);
  const loadingPosition = rest.startIcon ? "start" : "end";
  const nonLoadingStyling = rest.startIcon || rest.endIcon || loading ? {} : { padding: "0 .7rem" };
  const endIcon = rest.startIcon ? void 0 : /* @__PURE__ */ jsx4("span", { style: loading ? { padding: "0 .7rem" } : {} });
  return /* @__PURE__ */ jsx4(
    MUILoadingButton,
    __spreadProps(__spreadValues({
      endIcon,
      loadingPosition,
      loading,
      disableRipple: true,
      loadingIndicator: LoadingIndicator
    }, rest), {
      ref,
      children: /* @__PURE__ */ jsx4("span", { style: nonLoadingStyling, children })
    })
  );
});
export {
  Button,
  ButtonGroup,
  IconButton,
  LoadingButton
};
